export default __webpack_public_path__ + "static/media/keno_exit_btn.775ef758.png";